import React, {useContext} from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import {LanguageContext} from '../../../containers/Language/LanguageProvider';
import { LabelText } from '../../../components/Language';
import config  from '../../../common/const/config.json';
import envHelper  from '../../../common/env-helper';

const envObj=envHelper.setEnvironmentURLs(); 

export default function Help(props) { 
    const languageContext = useContext(LanguageContext);

    const handlerOpenBKeyHelpDoc = () => {
        if(languageContext && languageContext.language.id) {
            const helpDocBaseUrl = envObj.BKEY_HELP_DOC_BASE_URL;
            if(helpDocBaseUrl && config && config.bKeyHelpDoc) {
                const url = helpDocBaseUrl + config.bKeyHelpDoc[languageContext.language.id];
                window.open(url, "_blank");
            }
        }
    }
    const bKeyHelpTooltip = (
        <Tooltip id="bKeyHelp" style={{whiteSpace: "pre-wrap"}}>
          <LabelText tid="bKeyHelp" />
        </Tooltip>
    );

    return (
        <>
            {languageContext && <OverlayTrigger placement="bottom" overlay={bKeyHelpTooltip}>
                <div className="help-doc-icon" role="button" tabIndex="0"
                    onClick={handlerOpenBKeyHelpDoc}
                    onKeyDown={(e)=> { if(e.key === "Enter") { handlerOpenBKeyHelpDoc()} }}>
                </div>
            </OverlayTrigger>}
        </>
    )
}